import React from 'react';
import { TextInput, NumberInput, CodeEditor } from 'hyperdb-utils';

const EmailSettings = ({ smtpSettings, imapSettings, signature, onChange }) => {
  const handleChangeSmtp = (attributeName, { value }) => {
    const attrs = { ...smtpSettings, [attributeName]: value };
    onChange('smtpSettings', attrs);
  };
  const handleChangeImap = (attributeName, { value }) => {
    const attrs = { ...imapSettings, [attributeName]: value };
    onChange('imapSettings', attrs);
  };
  const handleChangeSignature = ({ value}) => onChange('signature', value);
  return (
    <div>
      <fieldset>
        <legend>SMTP</legend>
        <TextInput
          label="Account email"
          value={ smtpSettings.email }
          onChange={ handleChangeSmtp.bind(null, 'email') }
        />
        <TextInput
          label="Account name"
          value={ smtpSettings.name }
          onChange={ handleChangeSmtp.bind(null, 'name') }
        />
        <TextInput
          label="Host"
          value={ smtpSettings.host }
          onChange={ handleChangeSmtp.bind(null, 'host') }
        />
        <NumberInput
          label="Port"
          value={ smtpSettings.port }
          onChange={ handleChangeSmtp.bind(null, 'port') }
        />
        <TextInput
          label="Login"
          value={ smtpSettings.user }
          onChange={ handleChangeSmtp.bind(null, 'user') }
        />
        <TextInput
          label="Password"
          value={ smtpSettings.pass }
          onChange={ handleChangeSmtp.bind(null, 'pass') }
        />
        <label>Other settings</label>
        <CodeEditor
          mode="markdown"
          value={ smtpSettings.customParams || '' }
          onChange={ handleChangeSmtp.bind(null, 'customParams') }
        />
      </fieldset>
      <fieldset>
        <legend>IMAP</legend>
        <TextInput
          label="Host"
          value={ imapSettings.host }
          onChange={ handleChangeImap.bind(null, 'host') }
        />
        <NumberInput
          label="Port"
          value={ imapSettings.port }
          onChange={ handleChangeImap.bind(null, 'port') }
        />
        <TextInput
          label="Login"
          value={ imapSettings.user }
          onChange={ handleChangeImap.bind(null, 'user') }
        />
        <TextInput
          label="Password"
          value={ imapSettings.password }
          onChange={ handleChangeImap.bind(null, 'password') }
        />
        <label>Other settings</label>
        <CodeEditor
          mode="markdown"
          value={ imapSettings.customParams || '' }
          onChange={ handleChangeImap.bind(null, 'customParams') }
        />
      </fieldset>
      <fieldset>
        <legend>Signature</legend>
        <CodeEditor
          mode="markdown"
          value={ signature || '' }
          onChange={ handleChangeSignature }
        />
      </fieldset>
    </div>
  );
};

export default EmailSettings;



// WEBPACK FOOTER //
// ./src/frontend/init-wizard/EmailSettings.jsx